import React, { useMemo } from 'react'
import classNames from 'classnames'
import { Link } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'

import { MATCH_STATUS_SOON } from '../../../match-discussion/constants'
import {
  getImageUrl,
  getNameTeam,
  isNumber,
  getStartMatchDate,
  getStatusClass,
  getGameName,
  getStatusText,
} from '../utils'

import styles from './styles.module.scss'

const MatchItem = props => {
  const {
    tournamentName,
    name,
    tournamentMember1,
    tournamentMemberScore1,
    status,
    mode,
    startedAt,
    tournamentMemberScore2,
    tournamentMember2,
    tournamentStageType,
    game,
    round,
  } = props

  const gameName = useMemo(() => getGameName(game), [game])
  const statusText = useMemo(() => getStatusText(status), [status])
  const team1Score = useMemo(
    () =>
      status === MATCH_STATUS_SOON ? '-' : isNumber(tournamentMemberScore1),
    [status, tournamentMemberScore1]
  )
  const team2Score = useMemo(
    () =>
      status === MATCH_STATUS_SOON ? '-' : isNumber(tournamentMemberScore2),
    [status, tournamentMemberScore2]
  )

  return (
    <Link
      to={name ? `/match-discussion/${name}` : '#'}
      className={styles.matchItemLink}
    >
      <div className={styles.titleRow}>
        <div className={styles.title}>{tournamentName}</div>

        <div
          className={classNames(
            styles.statusBadge,
            styles[getStatusClass(status)]
          )}
        >
          {statusText}
        </div>
      </div>

      <div className={styles.gameInfo}>
        <div className={styles.gameName}>{gameName}</div>
      </div>

      <div className={styles.resultContainer}>
        {tournamentStageType === 'FFA' ? (
          <div className={styles.teamsWrapper}>
            <div className={styles.teamDescription}>
              <div className={styles.name}>{name ? name : ''}</div>
            </div>
            <div className={styles.teamDescription}>
              <div className={styles.name}>
                <FormattedMessage id='matches.tournament.ffa' />
              </div>
            </div>
            <div className={styles.teamDescription}>
              <div className={styles.name}>
                <FormattedMessage id='matches.round' /> {round?.name}
              </div>
            </div>
            <div className={styles.teamDescription}>
              <div className={styles.name}>
                <FormattedMessage id='matches.status' /> {status}
              </div>
            </div>
          </div>
        ) : (
          <div className={styles.teamsWrapper}>
            <div className={styles.matchLayout}>
              <div className={styles.teamSection}>
                <div className={styles.teamInfo}>
                  <img
                    className={styles.img}
                    src={getImageUrl(tournamentMember1)}
                    alt='tournament-member-1'
                  />
                  <div className={styles.name}>
                    {getNameTeam(tournamentMember1)}
                  </div>
                </div>
                <div className={styles.teamScore}>{team1Score}</div>
              </div>

              <div className={styles.vsSection}>
                <div className={styles.vsText}>VS</div>
                <div className={styles.scoreSeparator}>:</div>
              </div>

              <div className={styles.teamSection}>
                <div className={styles.teamInfo}>
                  <img
                    className={styles.img}
                    src={getImageUrl(tournamentMember2)}
                    alt='tournament-member-2'
                  />
                  <div className={styles.name}>
                    {getNameTeam(tournamentMember2)}
                  </div>
                </div>
                <div className={styles.teamScore}>{team2Score}</div>
              </div>
            </div>
          </div>
        )}
      </div>

      <div className={styles.time}>{getStartMatchDate(startedAt)}</div>
      {!!mode && <div className={styles.scoreDay}>{mode}</div>}
    </Link>
  )
}

export default MatchItem
